"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SingleSelectMenu = void 0;
const react_1 = __importStar(require("react"));
const Theme_1 = require("../../Theme/Theme");
const Icon_1 = require("../Icon/Icon");
const BaseComponents_1 = require("./BaseComponents");
const MenuItemText = Theme_1.styled.span `
  color: ${(props) => props.theme.gray};
  padding-right: 6px;
  flex: none;
  font-family: ${(props) => props.theme.font.family.proximaNova};
  font-size: ${(props) => `${props.fontSize || 16}px`};
`;
function returnIconSize(fontSize) {
    return fontSize === '14' ? '16' : '18';
}
const Menu = (props) => {
    const { onOptionSelected, menuLocation, menuOptions, fontSize, selectedOption, width, } = props;
    const [currentState, updateCurrentState] = react_1.useState(selectedOption);
    const handleSelectionChange = (option, index) => {
        const newOption = option === currentState ? undefined : option;
        updateCurrentState(newOption);
        onOptionSelected(newOption, newOption ? index : undefined);
    };
    return (react_1.default.createElement(BaseComponents_1.MenuContainer, { className: "SingleSelectMenuContainer", menuLocation: menuLocation, width: width }, menuOptions.map((option, index) => (react_1.default.createElement(BaseComponents_1.MenuItem, { onClick: () => handleSelectionChange(option, index), key: `SingleSelectMenu_${option}` },
        react_1.default.createElement(MenuItemText, { key: `SingleSelectMenu_${option}_text` }, option),
        option === currentState && (react_1.default.createElement(Icon_1.Icon, { key: `SingleSelectMenu_selected_icon`, icon: 'check', size: returnIconSize(fontSize) })))))));
};
const SortMenu = (props) => {
    const { onSortOptionSelected, menuLocation, menuOptions, fontSize, selectedOption, sortDirection, } = props;
    const defaultState = {
        internalSelectedOption: selectedOption || '',
        internalSortDirection: sortDirection,
    };
    const [currentState, updateCurrentState] = react_1.useState(defaultState);
    const { internalSelectedOption, internalSortDirection } = currentState;
    const iconToDisplay = (internalSortDirection === null || internalSortDirection === void 0 ? void 0 : internalSortDirection.toUpperCase()) === 'ASC' ? 'arrowDown' : 'arrowUp';
    const handleSelectionChange = (option, index) => {
        const newState = Object.assign({}, currentState);
        if (internalSelectedOption != option) {
            newState.internalSelectedOption = option;
            internalSortDirection ? null : (newState.internalSortDirection = 'ASC');
        }
        else {
            newState.internalSortDirection =
                internalSortDirection === 'ASC' ? 'DESC' : 'ASC';
            newState.internalSelectedOption = option;
        }
        updateCurrentState(newState);
        onSortOptionSelected(option, newState.internalSortDirection, index);
    };
    return (react_1.default.createElement(BaseComponents_1.MenuContainer, { className: "SingleSelectMenuContainer", menuLocation: menuLocation }, menuOptions.map((option, index) => (react_1.default.createElement(BaseComponents_1.MenuItem, { onClick: () => handleSelectionChange(option, index), key: `SingleSelectMenu_${option}` },
        react_1.default.createElement(MenuItemText, { key: `SingleSelectMenu_${option}_text` }, option),
        option === internalSelectedOption && (react_1.default.createElement(Icon_1.Icon, { key: `SingleSelectMenu_selected_icon`, icon: iconToDisplay, size: returnIconSize(fontSize) })))))));
};
exports.SingleSelectMenu = (props) => {
    function isSortMenu(props) {
        return (props.onSortOptionSelected !== undefined);
    }
    const [isMenuOpen, setMenuOpen] = react_1.useState(false);
    const handleClickOutside = () => {
        isMenuOpen && setMenuOpen(false);
    };
    react_1.useEffect(() => {
        document.addEventListener('click', handleClickOutside);
        return () => {
            document.removeEventListener('click', handleClickOutside);
        };
    }, [isMenuOpen]);
    const handleParentClick = () => {
        setMenuOpen(!isMenuOpen);
    };
    const ClonedVisualEle = react_1.cloneElement(props.VisualElement, {
        onClick: handleParentClick,
    });
    const menuClassName = isSortMenu(props)
        ? 'SingleSelectSortMenu'
        : 'SingleSelectMenu';
    const menuToRender = isSortMenu(props) ? (react_1.default.createElement(SortMenu, Object.assign({}, props))) : (react_1.default.createElement(Menu, Object.assign({}, props)));
    return (react_1.default.createElement(BaseComponents_1.MenuComponentWrapper, { className: menuClassName, width: props.width },
        ClonedVisualEle,
        isMenuOpen && menuToRender));
};
//# sourceMappingURL=SingleSelectMenu.js.map